import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { useVendorPartners } from "~/hooks/vendors/useVendorPartners";
import type { DealSearchCondition } from "~/models/Deal";
import type { VendorPartner } from "~/models/VendorPartner";
import { convertToComboBoxOption } from "~/models/VendorPartner";

type SingleComboBoxOption = Exclude<
	ComponentProps<typeof SingleComboBox>["options"][number],
	{ group: string }
>;

const NO_VENDOR_PARTNER_ID = -1;

const noVendorPartnerOption: SingleComboBoxOption = {
	label: "実施会社未指定",
	value: String(NO_VENDOR_PARTNER_ID)
};

export function VendorPartnerCombobox() {
	const { data: vendorPartners, isLoading } = useVendorPartners().index();
	const { setValue, watch } = useFormContext<DealSearchCondition>();
	const watchedPartnerVendorId = watch("partnerVendorId");

	const vendorPartnerOptions: SingleComboBoxOption[] = [
		noVendorPartnerOption
	].concat(
		vendorPartners?.map((vp: VendorPartner) => convertToComboBoxOption(vp)) ??
			[]
	);

	const selectedVendorPartnerOption: SingleComboBoxOption | null =
		watchedPartnerVendorId === undefined
			? null
			: watchedPartnerVendorId === NO_VENDOR_PARTNER_ID
				? noVendorPartnerOption
				: vendorPartnerOptions.find(
						({ value }) => value === String(watchedPartnerVendorId)
					)!;

	const onVendorPartnerChange = useCallback(
		(value: SingleComboBoxOption | null) => {
			if (!value) {
				setValue("partnerVendorId", undefined);
			} else {
				setValue("partnerVendorId", Number(value.value));
			}
		},
		[setValue]
	);
	if (isLoading) {
		return null;
	}
	return (
		<SingleComboBox
			onChange={onVendorPartnerChange}
			options={vendorPartnerOptions}
			placeholder="実施会社"
			value={selectedVendorPartnerOption}
		/>
	);
}
